<div class="p-3">
    <div class="d-flex flex-row align-items-center justify-content-between">
        <h3 class="mb-0">Promotion</h3>
        <div class="d-flex flex-row gap-2">
            <button class="btn btn-sm btn-success" (click)="addPromotion()">Add Promotion</button>
            <button class="btn btn-sm btn-warning" (click)="close()">CLOSE</button>
        </div>
    </div>
    <hr/>

    <div *ngIf="adding_promotion">
        <h3 class="mb-3">You are adding custom promotion for player.</h3>
        <p>Please note this only support Social Media Promotion & Birthday Promotion.</p>
        <ng-container *ngIf="promotions.length > 0">
            <div class="input-group mb-3">
                <select class="form-select" [(ngModel)]="promotion_type">
                    <option *ngFor="let promotion of promotions" [value]="promotion.id">{{promotion.title}}</option>
                </select>
                <div class="input-group-append">
                    <button class="btn border border-dark" [disabled]="!promotion_type" (click)="newPromotion()">Add Promotion</button>
                </div>
            </div>

        </ng-container>
        <ng-container *ngIf="promotions.length == 0">
            <h5 class="text-danger">No promotion found. Please create promotion first. Only Support Social Media Promotion & Birthday Promotion.</h5>
        </ng-container>
        <hr/>
    </div>

    <div *ngIf="!lock.status && lock.message">
        <h5 class="text-danger">{{lock.message}}</h5>
    </div>

    <div *ngIf="lock.status">
        <table>
            <tr>
                <th colspan="2">{{lock.promo_title}} ({{lock.type}})</th>
            </tr>
            <tr>
                <th>{{lock.withdraw_type == "rolling" || lock.withdraw_type == "rolling-fixed" ? "Rolling" : "Turnover"}} Requirement</th>
                <td>{{lock.progress}} / {{lock.min_rolling}}</td>
            </tr>
            <tr>
                <th>Balance Before</th>
                <td>{{lock.balance_before}}</td>
            </tr>
            <tr>
                <th>Bonus (Free Credit)</th>
                <td>{{lock.free_credit}}</td>
            </tr>
            <tr>
                <th>Balance After Bonus Credit</th>
                <td>{{lock.balance_after}}</td>
            </tr>
            <tr>
                <th>Minimum Withdrawal</th>
                <td>{{lock.minimum_withdraw}}</td>
            </tr>
            <tr>
                <th>Maximum Withdrawal</th>
                <td>{{lock.maximum_withdraw}}</td>
            </tr>
            <tr>
                <th>Join On</th>
                <td>{{lock.timestamp | date: 'short'}}</td>
            </tr>

        </table>

        <div class="card mt-3" *ngIf="lock.progress < lock.min_rolling">
            <div class="card-header">
                <h5 class="card-title mb-0">Cancel Promotion</h5>
            </div>
            <div class="card-body">
                <div>
                    <label for="name" class="form-label">Wallet Adjustment</label>
                    <input type="number" class="form-control form-contrl-lg" [(ngModel)]="lock.adjustment"/>
                    <p class="text-muted small">This is final wallet balance.</p>
                </div>
                <div>
                    <label for="name" class="form-label">Remark</label>
                    <input type="text" class="form-control form-contrl-lg" [(ngModel)]="lock.remark"/>
                </div>
                <button (click)="cancelPromotion()" class="btn btn-sm w-100 btn-success mt-3">Cancel Promotion Withdraw & Exit Game</button>
            </div>
        </div>

        <div class="card mt-3" *ngIf="lock.progress >= lock.min_rolling">
            <div class="card-header">
                <h5 class="card-title mb-0">End Promotion</h5>
            </div>
            <div class="card-body">
                <button (click)="endPromotion()" class="btn btn-sm w-100 btn-success mt-3">End Promotion</button>
            </div>
        </div>
        
        <button (click)="close()" class="btn btn-sm w-100 btn-warning  mt-3">Close</button>
    </div>
    
</div>